var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PreviewLabel from "../PreviewLabel";
import "./PreviewMedia.scss";

// Components

import PreviewImage from './PreviewImage';
import PreviewVideo from './PreviewVideo';
import PreviewAudio from './PreviewAudio';

var templates = {
  "image": PreviewImage,
  "video": PreviewVideo,
  "audio": PreviewAudio

  // Class

};var PreviewMedia = (_temp2 = _class = function (_Component) {
  _inherits(PreviewMedia, _Component);

  function PreviewMedia() {
    var _temp, _this, _ret;

    _classCallCheck(this, PreviewMedia);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getMediaType = function () {
      var media = _this.props.formData.media;


      if (!media) {
        return undefined;
      }

      var mediaType = media.mediaType,
          imageUrl = media.imageUrl;


      if (mediaType) {
        return mediaType;
      } else if (imageUrl) {
        return "image";
      }

      return undefined;
    }, _this.getClassName = function () {

      var mediaType = _this.getMediaType();

      var classNames = [];

      classNames.push('field__media');

      if (mediaType) {
        classNames.push('media--' + mediaType);
      }

      return classNames.join(' ');
    }, _this.renderMedia = function () {
      var _this$props = _this.props,
          formData = _this$props.formData,
          format = _this$props.format;
      var mediaId = formData.mediaId,
          media = formData.media,
          content = formData.content;

      var _ref = media || {},
          title = _ref.title,
          mediaType = _ref.mediaType,
          imageUrl = _ref.imageUrl,
          resources = _ref.resources;

      var className = _this.getClassName();

      var MediaTemplate = void 0;

      if (templates[mediaType] && resources) {
        MediaTemplate = templates[mediaType];
      } else if (imageUrl) {
        MediaTemplate = templates["image"];
      }

      if (MediaTemplate) {

        return React.createElement(
          "div",
          { className: className, "data-format": format },
          React.createElement(MediaTemplate, _this.props)
        );
      }

      return React.createElement(
        "div",
        { className: className, "data-format": format },
        React.createElement(
          "div",
          { className: "media__preview" },
          React.createElement(
            "h2",
            { className: "media__title" },
            title
          ),
          React.createElement(
            "h2",
            { className: "media__description" },
            mediaType
          )
        )
      );
    }, _this.renderContent = function () {
      var content = _this.props.formData.content;


      if (!content) {
        return false;
      }

      return false;

      var headline = content.headline,
          description = content.description,
          category = content.category,
          creditLine = content.creditLine;


      if (creditLine) {

        return React.createElement(
          "figcaption",
          { className: "media__caption" },
          React.createElement(
            "strong",
            null,
            headline
          ),
          " ",
          ' ',
          description,
          " ",
          ' ',
          React.createElement(
            "em",
            { className: "media__credit", "data-prefix": category },
            creditLine
          )
        );
      }

      return React.createElement(
        "figcaption",
        { className: "media__caption" },
        React.createElement(
          "strong",
          null,
          headline
        ),
        " ",
        ' ',
        description
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PreviewMedia.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        formData = _props.formData;


    if (!formData) {
      return false;
    }

    var mediaType = this.getMediaType();

    return React.createElement(
      "figure",
      { className: "admin-preview__field  field--media" },
      React.createElement(PreviewLabel, { id: id || "media", type: mediaType }),
      this.renderMedia(),
      this.renderContent()
    );
  };

  return PreviewMedia;
}(Component), _class.defaultProps = {
  format: "16:9"
}, _temp2);


export default PreviewMedia;